export const ytUrl = `https://www.youtube.com/watch?v=`
export const YOUTUBE_VIDEO_ID_REGEXP = /^.*?\$/

export const sliderMovementType = {
  DEFAULT: 'default',
  PROGRESSIVE: 'progressive',
  PUSH: 'push',
}

export enum dataWidgetProvider {
  STATS_PERFORM = 'StatsPerform',
}

export enum dataWidgetTypes {
  STANDINGS = 'Standings',
  MATCH = 'Match',
  MATCHES = 'Matches',
  COMMENTARY = 'Commentary',
  TEAM_PAGE_COMMENTARY = 'TeamPageCommentary',
}

export enum commentaryTypes {
  MANUAL = 'Manual',
  AUTO = 'Auto',
  FALLBACK = 'Fallback',
}

export const commentaryMessageTypes = {
  GOAL: 'goal',
  PENALTY_GOAL: 'penalty goal',
  OWN_GOAL: 'own goal',
  RED_CARD: 'red card',
  YELLOW_CARD: 'yellow card',
  SECOND_YELLOW_CARD: 'second_yellow red card',
  SUBSTITUTION: 'substitution',
}

export enum pageTypes {
  CLASSIC_HOME = 'ClassicHome',
  HOME_TAB = 'HomeTab',
  GRID = 'Grid',
  LINES = 'Lines',
  SECTION_GRID = 'SectionGrid',
  TABS = 'Tabs',
  LANDING = 'Landing',
  DATA_WIDGET = 'DataWidget',
  HTML_WIDGET = 'HtmlWidget',
  CATALOGUE = 'Catalogue',
  FOCUS = 'Focus',
}

export enum catalogueTypes {
  CATEGORY = 'Category',
  CHANNEL = 'Channel',
}

export enum sortTypes {
  ALPHABETICAL = 'Alphabetical',
}

export enum lineTypes {
  LARGE_TILES = 'LargeTiles',
  CLASSIC_TILES = 'ClassicTiles',
  SQUARE_TILES = 'SquareTiles',
}

export enum LineTileShape {
  ASPECT16x9 = '16By9',
  SQUARE = 'Square',
  CIRCLE = 'Circle',
  ASPECT2x3 = '2By3',
  ASPECT9x16 = '9By16',
}

export enum LineTileSize {
  LARGE = 'Large',
  DEFAULT = 'Default',
  SMALL = 'Small',
  XSMALL = 'XSmall',
}

export enum fetchStatus {
  IDLE = 'IDLE',
  FETCHING = 'FETCHING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum consentLoadedStatus {
  LOADED = 'LOADED',
  INITIALIZED = 'INITIALIZED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum constantsBroadcastIds {
  CHANNEL_PLAYER = 'ChannelPlayer',
  HOME_GRID = 'HomeGrid',
  CLASSIC_HOME = 'ClassicHome',
}

export enum BgImagePositions {
  SCROLLING = 'scrolling',
  FIXED = 'fixed',
}

/**
 * refreshIntervalThreshold in seconds
 */
export const refreshIntervalThreshold = 30

export const playerCloseOnEnd = false
export const scrollBarOffset = 200

export const pressDelay = 150
export const qrCodeUrl = 'http://onelink.to/3cncst'
export const qrSize = 168

export const headerHeight = '278px'

export const dotSize = '0px'

export const lineHeight = '8px'

export const commonDefaultAppConfig = {
  version: 'local',
  welcomeScreenCounter: 2,
  showWelcomeScreenForModelYear: ['2022'],
  limitSpacesPerGrid: 6,
  refreshInterval: 15 * 60,
  cacheDuration: 5 * 60,
  channelsLimit: 50,
  cataloguePagesLimit: 50,
  disabledMenuItems: [],
  useUtcOffsetMins: true,
  useCache: true,
}

export const authUser = {
  ANONYMOUS: 'anonymous',
  REGISTERED: 'registered',
}

export const refreshTokensMaxRetryCount = 3
export const refreshTokensRetryDelayMs = 2000

export const MAX_SAVE_32BIT_INT = 2147483647
